import React, { useEffect, useState } from 'react'
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from '@react-pdf/renderer'
import moment, { Moment } from 'moment'
import * as Datetime from 'react-datetime'
import { IActiveTripResponseV2, ITripLogReq, ITripStatusesObj } from 'src/types'
import Select from 'react-select'
import UIMessages from 'src/utils/ui-messages'

interface IModivTripLogPDFProps {
  dailyTripLogs: any[]
  getTripLogPerServiceAndDateRange: (params: ITripLogReq) => any
  serviceId: string
}

interface ISelectOption {
  label: string
  value: any
}

// Create styles
const styles = StyleSheet.create({
  /* page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  }, */

  headerTop: {
    flexDirection: 'row',
    marginBottom: 8
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: '100'
  },
  headerLeftInfo: {
    width: '30%',
    paddingLeft: 10
  },
  headerRightInfo: {
    width: '70%',
    paddingRight: 20
  },
  headerData: {
    fontSize: '12',
    borderBottom: '1px solid black',
    paddingBottom: 2
  },
  headerCaption: {
    fontSize: 8,
    color: 'red'
  },
  section: {
    marginLeft: 10,
    marginTop: 20,
    padding: 10,
    flexGrow: 1,
    fontSize: 14
    // fontWeight:
  },

  font: {
    fontSize: 10,
    marginRight: 20,
    marginTop: 20
  },

  /* Table */
  table: {
    fontSize: 10,
    width: 1000,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    flexWrap: 'nowrap',
    alignItems: 'stretch'
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    minHeight: '4.5em'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
    // justifyContent: 'space-around',
    // alignContent: 'stretch',
    // flexWrap: 'nowrap',
    // alignItems: 'stretch',
    // flexGrow: 0,
    // flexShrink: 0,
    // flexBasis: 35
  },
  cell: {
    /* borderColor: 'black',
    borderStyle: 'solid',
    borderWidth: 1, */
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    alignSelf: 'stretch',
    fontSize: 10
    /* marginLeft: 20,
    marginRight:20 */
  },
  header: {
    border: '1px solid black'
  },
  bodyRow: {
    borderTop: 0,
    borderBottom: '1px solid black',
    borderRight: '1px solid black'
  },
  headerText: {
    fontSize: 10,
    color: 'black',
    verticalAlign: 'middle'
  },
  bodyText: {
    fontSize: 10,
    color: 'black',
    verticalAlign: 'middle',
    flexWrap: 'wrap'
  },
  topTableHeader: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black'
  },
  topTableHeaderText: {
    fontSize: 10,
    color: 'black',
    verticalAlign: 'middle'
  },
  topTableBodyText: {
    fontSize: 12,
    color: 'black',
    verticalAlign: 'middle'
  },
  tableText: {
    margin: 10,
    marginLeft: 10,
    fontSize: 10,
    color: 'black'
  },
  body: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20
  },
  image: {
    height: 18,
    width: 40
  },
  imageSignature: {
    marginTop: -16,
    height: 18,
    width: 30
  },
  headerOneLine: {
    textAlign: 'left',
    borderLeft: '1px solid black',
    minHeight: '2.5em',
    padding: 2
  },
  topTableHeaderOneLine: {
    textAlign: 'left',
    borderLeft: '1px solid black',
    minHeight: '2.5em',
    padding: '0'
  },
  headerTwoLines: {
    textAlign: 'center',
    borderLeft: '1px solid black',
    minHeight: '4em',
    padding: 2
  },
  bodyOneLine: {
    textAlign: 'center',
    borderLeft: '1px solid black',
    minHeight: '3em',
    flexGrow: 1,
    padding: 2
  },
  bodyTwoLines: {
    textAlign: 'center',
    borderLeft: '1px solid black',
    flexGrow: 1,
    padding: 2
  },
  dataLine: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    minHeight: '1.2em',
    fontSize: 10,
    paddingVertical: 5,
    paddingLeft: 5,
    paddingRight: 5
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20
  }
  /* Table */
})
// add wheel chair and amlble ids here. Ids now are shareeable bus and mega Bus updated
const devOptions = [
  { label: 'Amble', value: '0a8c538b-7a32-4cd9-ae13-14dde3854a34' },
  { label: 'WheelChair', value: '7e0840a4-f2ec-4a0e-9677-e468f8235f86' },
  { label: 'Stretcher', value: '2ca998ff-223e-4f21-9d6c-503dc6645351' }
]

const prodOptions = [
  { label: 'Amble', value: '5f8918a8-4183-4316-be4e-fb054cc0ad1f' },
  { label: 'WheelChair', value: 'a7861dcd-4e0a-44af-8731-d972348e97b0' },
  { label: 'Stretcher', value: '0061349a-74db-47d2-bc91-342a81c3e2e6' }
]
const options =
  process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_TEST_MODIVCARE === 'true'
    ? prodOptions
    : devOptions
const serviceId =
  process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_TEST_MODIVCARE === 'true'
    ? 'd343b302-1e9d-4031-83b5-0706ebe2a9ac'
    : 'e5bc445a-1347-455b-a677-52f44c0a3e76'

export const ModivcareTripLogPDFNew = (props: IModivTripLogPDFProps) => {
  const [isSubmitted, setIsSubmited] = React.useState(false)
  const [fromDateFilter, setFromDate] = React.useState(
    moment()
      .startOf('day')
      .subtract(7, 'day')
      .toISOString()
  )
  const [toDateFilter, setToDate] = React.useState(
    moment()
      .endOf('day')
      .toISOString()
  )
  const [filterMessage, setFilterMessage] = React.useState('')
  const [fromDateDisplay, setFromDateDisplay] = React.useState(
    moment()
      .startOf('day')
      .subtract(7, 'days')
      .format('MM/DD/YYYY hh:mmA')
  )
  const [toDateDisplay, setToDateDisplay] = React.useState(
    moment()
      .endOf('day')
      .format('MM/DD/YYYY hh:mmA')
  )
  const [productIds, setProductId] = React.useState([options[0].value])
  const filename = `ModivcareTripLog-${moment().format('YYYY-MM-DD HH:MM:SS')}`

  const setFromDateFilter = (e: Moment) => {
    if (moment(e).isValid()) {
      const fromDate = e.startOf('day')
      const fromDateISO = fromDate.toISOString()
      const toDate = moment(toDateFilter).endOf('day')

      if (fromDate > toDate) {
        setFilterMessage(`Please choose a earlier date than ${toDateDisplay}`)

        return
      } else {
        setFilterMessage('')
      }
      setFromDate(fromDateISO)
      setToDate(toDate.toISOString())
      setFromDateDisplay(fromDate.format('MM/DD/YYYY hh:mmA'))
      setToDateDisplay(toDate.format('MM/DD/YYYY hh:mmA'))
    }
  }
  const setToDateFilter = (e: Moment) => {
    if (moment(e).isValid()) {
      const toDate = e.endOf('day')
      const toDateISO = toDate.toISOString()
      const fromDate = moment(fromDateFilter).startOf('day')

      if (fromDate > toDate) {
        setFilterMessage(`Please choose a later date ${fromDateDisplay}`)
        return
      } else {
        setFilterMessage('')
      }
      setFromDate(fromDate.toISOString())
      setToDate(toDateISO)
      setFromDateDisplay(fromDate.format('MM/DD/YYYY hh:mmA'))
      setToDateDisplay(toDate.format('MM/DD/YYYY hh:mmA'))
    }
  }

  const formatDateTime = (date: string | undefined, format: 'MM/DD/YY' | 'HH:mm' | string) => {
    if (date) {
      return moment(date).format(format)
    }
    return ''
  }

  const convertToMiles = (meters: number) => {
    return Math.round(meters / 1609.344)
  }

  const selectProductIds = (selectedIds: ISelectOption[]) => {
    let productIds = []
    if (selectedIds) {
      productIds = selectedIds.map((op: any) => op.value)
    }
    setProductId(productIds)
  }

  const getPickedUpTime = (statuses: ITripStatusesObj[]): string => {
    const status = statuses.find(stat => stat.status === 'PICKED_UP')
    if (status) {
      return formatDateTime(status.createdAt, 'HH:mm')
    }
    return ''
  }

  const getWillCallTime = (statuses: ITripStatusesObj[]): string => {
    const status = statuses.find(stat => stat.status === 'WILL_CALL')
    if (status) {
      return formatDateTime(status.createdAt, 'HH:mm')
    }
    return ''
  }

  const getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  // below code is for testing purposes, undeleted for fast testing connected in prod
  // const getBucketName = () => {
  //   return process.env.REACT_APP_S3_BUCKET_PROD
  // }
  let recordOfTrips: any[] = []
  let odometerRecord: any[] = []

  async function imageExists(imageUrl: string | null) {
    if (!imageUrl) {
      return false
    }

    const http = new XMLHttpRequest()

    http.open('HEAD', imageUrl, false)
    http.send()
    return http.status !== 404 && http.status !== 403
  }

  const IMGSignature = ({ tripSignature }: { tripSignature: string | null }) => {
    const [isImageValid, setIsImageValid] = useState(false)

    useEffect(() => {
      const checkImage = async () => {
        if (tripSignature) {
          const valid = await imageExists(tripSignature)
          setIsImageValid(valid)
        }
      }
      checkImage()
    }, [tripSignature])

    return (
      <View style={[{ width: '16%' }]}>
        <View style={[styles.bodyTwoLines]}>
          <Text style={[styles.bodyText]}>
            {isImageValid && tripSignature ? (
              <Image style={styles.imageSignature} src={tripSignature} />
            ) : (
              <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>
            )}
          </Text>
        </View>
      </View>
    )
  }
  const IMGDriverSignature = ({ signature }: { signature: string | null }) => {
    const [isImageValid, setIsImageValid] = useState(false)

    useEffect(() => {
      const checkImage = async () => {
        if (signature) {
          const valid = await imageExists(signature)
          setIsImageValid(valid)
        }
      }
      checkImage()
    }, [signature])

    return (
      <View style={{ width: '25%', marginRight: 10 }}>
        <Text style={[styles.headerData, { marginTop: 'auto' }]}>
          {isImageValid && signature ? (
            <Image style={styles.imageSignature} src={signature} cache={true} />
          ) : (
            <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>
          )}
        </Text>
        <Text style={{ fontSize: 10 }}>Driver's/Provider's Signature</Text>
      </View>
    )
  }

  const ModivCareTripLog = (props: any) => {
    if (props.dailyTripsLog) {
      return (
        <Document>
          {props.dailyTripsLog.map((item: any) => {
            const operatorKey = Object.keys(item)[0]
            const logItem = item[operatorKey]
            const tripLogs = logItem.trips ? logItem.trips : null
            const driver = logItem.operator ? logItem.operator : null
            const provider = logItem.provider ? logItem.provider : null

            const driverName = `${driver.firstName} ${driver.lastName}`

            const driversLicense = driver.driversLicense

            const driverSignature =
              tripLogs[0] && tripLogs[0].driverSignature !== '' && tripLogs[0].driverSignature != null
                ? `https://${getBucketName()}.s3.amazonaws.com/uploads/signatures/driver/${tripLogs[0].driverSignature}`
                : null
            displayTripsContent(tripLogs)

            const isModivCare = () => {
              return (
                tripLogs.length > 0 &&
                tripLogs[0].service &&
                tripLogs[0].service.name.toLowerCase().includes('modivcare')
              )
            }
            return (
              <Page size='LETTER' style={styles.body} wrap={false} key={operatorKey} orientation='landscape'>
                {/* Headers */}
                <View style={styles.headerTop}>
                  <div style={{ width: '20%' }}>
                    <div style={styles.row}>
                      <Text style={{ fontSize: '22' }}>modiv</Text>
                      <Text style={{ fontSize: '22' }}>care</Text>
                    </div>
                  </div>
                  <div style={{ width: '80%', textAlign: 'right' }}>
                    <Text style={[styles.headerTitle]}>Non-Emergency Transportation Trip Log</Text>
                  </div>
                </View>
                <View style={[styles.row, { marginBottom: 2 }]}>
                  <View style={{ flexDirection: 'row' }}>
                    <View style={[styles.row, { width: '70%', alignSelf: 'flex-start', textAlign: 'justify' }]}>
                      <Text style={styles.headerCaption}>
                        Completed forms are to be submitted through the Modivcare Transportation Portal at
                        transportationco.modivcare.com.
                      </Text>
                    </View>
                    <View style={[styles.row, { width: '30%', alignSelf: 'flex-end', alignContent: 'flex-end' }]}>
                      <Text style={{ fontSize: '11', paddingRight: '5' }}>Week Ending</Text>
                      <Text style={styles.headerData}>
                        {fromDateDisplay.substring(0, 10)} - {toDateDisplay.substring(0, 10)}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Headers */}

                {/* Top Table */}
                <Text style={{ fontSize: '10', fontWeight: 'bold' }}>PROVIDER INFORMATION</Text>
                <View style={[styles.row, styles.topTableHeader]}>
                  <View style={[{ width: '15%' }]}>
                    <View style={[styles.topTableHeaderOneLine]}>
                      <Text style={[styles.topTableHeaderText]}>Provider Name</Text>
                      <Text style={[styles.topTableBodyText, { textAlign: 'center' }]}>
                        {provider && provider.name ? provider.name : <Text />}
                      </Text>
                    </View>
                  </View>
                  <View style={[{ width: '35%' }]}>
                    <View style={[styles.topTableHeaderOneLine]}>
                      <Text style={[styles.topTableHeaderText]}>Provider ID</Text>
                      <Text style={[styles.topTableBodyText, { textAlign: 'center' }]}>&nbsp;</Text>
                    </View>
                  </View>
                  <View style={[{ width: '35%' }]}>
                    <View style={[styles.topTableHeaderOneLine]}>
                      <Text style={[styles.topTableHeaderText]}>Driver Name</Text>
                      <Text style={[styles.topTableBodyText, { textAlign: 'center' }]}>
                        {driverName ? driverName : <Text />}
                      </Text>
                    </View>
                  </View>
                  <View style={[{ width: '15%' }]}>
                    <View style={[styles.topTableHeaderOneLine]}>
                      <Text style={[styles.topTableHeaderText]}>State</Text>
                      <Text style={[styles.topTableBodyText, { textAlign: 'center' }]}>
                        {isModivCare() ? 'WA' : <Text />}
                      </Text>
                    </View>
                  </View>
                </View>
                {/* Top Table */}

                {/*Record of Trips*/}
                <Text style={{ fontSize: '10', fontWeight: 'bold', marginTop: 8 }}>RECORD OF TRIPS</Text>
                <View style={[styles.row, styles.header]}>
                  <View style={[{ width: '1%' }]}>
                    <Text>&nbsp;</Text>
                  </View>
                  <View style={[{ width: '10%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Vehicle VIN</Text>
                      <Text style={[styles.headerText]}>(Last 6 digits)</Text>
                    </View>
                  </View>
                  <View style={[{ width: '7%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Trip Date</Text>
                      <Text style={[styles.headerText]}>&nbsp;</Text>
                    </View>
                  </View>
                  <View style={[{ width: '10%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Job #</Text>
                      <Text style={[styles.headerText]}>A or B</Text>
                    </View>
                  </View>
                  <View style={[{ width: '13%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Member Name</Text>
                      <Text style={[styles.headerText]}>&nbsp;</Text>
                    </View>
                  </View>

                  <View style={[{ width: '6%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Pick-Up</Text>
                      <Text style={[styles.headerText]}>Time</Text>
                    </View>
                  </View>
                  <View style={[{ width: '6%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Drop-Off</Text>
                      <Text style={[styles.headerText]}>Time</Text>
                    </View>
                  </View>
                  <View style={[{ width: '7%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Will Call</Text>
                      <Text style={[styles.headerText]}>Time</Text>
                    </View>
                  </View>
                  <View style={[{ width: '8%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Total Trip</Text>
                      <Text style={[styles.headerText]}>Mileage</Text>
                    </View>
                  </View>
                  <View style={[{ width: '11%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Late Reason</Text>
                      <Text style={[styles.headerText]}>Code {'(FL ONLY)'}</Text>
                    </View>
                  </View>
                  <View style={[{ width: '10%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Per Trip Billed</Text>
                      <Text style={[styles.headerText]}>Amount</Text>
                    </View>
                  </View>
                  <View style={[{ width: '16%' }]}>
                    <View style={[styles.headerTwoLines]}>
                      <Text style={[styles.headerText]}>Member or Attendant's Signature</Text>
                    </View>
                  </View>
                </View>

                {/* Record of Trips */}
                {recordOfTrips}

                <View>
                  <View style={{ flexDirection: 'row' }}>
                    <Text style={{ fontSize: '8' }}>
                      *NOTE** Leg of transport-a leg of transport is the point of pick-up to the destination Example:
                      Picking recipient up at residence and transporting to the doctor's office would be considered one
                      leg picking the recipient up at the doctor's office and transporting back to the residence would
                      be considered the second leg of the trp Each leg of the transport must be documented on separate
                      lines. A signature is required for each leg of the transport Pick-up and drop-off times must be
                      documented and in military time.
                    </Text>
                    <Text>{'\n'}</Text>
                    <Text>{'\n'}</Text>
                  </View>

                  <View style={{ flexDirection: 'row', marginTop: 10 }}>
                    <Text style={{ fontSize: '10' }}>
                      Drivers Comments: __________________________________________________________________________
                    </Text>
                    <Text>{'\n'}</Text>
                  </View>
                </View>

                <Text style={{ fontSize: '10' }}>West Virginia ONLY Beginning and Ending Odometer Readings</Text>
                <View style={[styles.row, styles.header, { margin: 0, padding: 0, minHeight: '2em' }]}>
                  <View style={[{ width: '1%' }]} />

                  <View style={[{ width: '25%' }]}>
                    <Text style={[styles.headerOneLine, styles.headerText]}>Beginning Odometer</Text>
                  </View>
                  <View style={[{ width: '25%' }]}>
                    <Text style={[styles.headerOneLine, styles.headerText]}>Ending Odometer</Text>
                  </View>

                  <View style={[{ width: '1%', borderLeft: '1px solid black' }]} />
                  <View style={[{ width: '25%' }]}>
                    <Text style={[styles.headerOneLine, styles.headerText]}>Beginning Odometer</Text>
                  </View>
                  <View style={[{ width: '25%' }]}>
                    <Text style={[styles.headerOneLine, styles.headerText]}>Ending Odometer</Text>
                  </View>
                </View>

                <View style={[{ height: 70, display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }]}>
                  {odometerRecord}
                </View>
                <Text style={{ fontSize: '8', paddingBottom: 10, paddingTop: 0 }}>
                  In the above, for trips in the state of WV, provide the beginning and ending odometer readings for the
                  corresponding number trip listed under RECORD OF TRIPS.
                </Text>

                <Text style={{ fontSize: '10', paddingBottom: 5 }}>SIGNATURE OF ACCURACY</Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ fontSize: '10' }}>
                    I understand that Modivcare will verify the accuracy of the mileage being reported and I hereby
                    certify the information herein is true, correct, and accurate.
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: 'row',
                    textAlign: 'left',
                    left: 10,
                    display: 'flex',
                    minHeight: 50
                  }}
                >
                  <IMGDriverSignature signature={driverSignature} />
                  <View style={{ width: '40%', marginRight: 10 }}>
                    <Text style={[styles.headerData, { marginTop: 'auto' }]}>{driverName}</Text>
                    <Text style={{ fontSize: 10 }}>
                      Print Driver/Provider’s Name (as it appears on driver’s license)
                    </Text>
                  </View>
                  <View style={{ width: '25%' }}>
                    <Text style={[styles.headerData, { marginTop: 'auto' }]}>
                      {driversLicense && driversLicense !== '' ? driversLicense : <Text>&nbsp;</Text>}
                    </Text>
                    <Text style={{ fontSize: 10 }}>Driver’s License Number</Text>
                  </View>
                </View>
              </Page>
            )
          })}
        </Document>
      )
    }
    return <div />
  }

  const displayTripsContent = (tripLogs: IActiveTripResponseV2[]) => {
    recordOfTrips = []
    odometerRecord = []

    for (let idx = 0; idx < 8; idx++) {
      const trip: any = tripLogs && tripLogs[idx] ? tripLogs[idx] : null
      recordOfTrips.push(<RecordOfTripsRow key={idx} trip={trip} tripIndex={idx + 1} />)
      odometerRecord.push(<OdometerRecord key={idx} trip={trip} tripIndex={idx + 1} />)
    }
  }

  interface RecordOfTripsProp {
    trip: IActiveTripResponseV2 | undefined
    tripIndex: number
  }

  const RecordOfTripsRow = (prop: RecordOfTripsProp) => {
    const trip = prop.trip
    const details: { billingCode: string; originalPickAddr: string; originalDropAddr: string } = trip
      ? trip.details
      : null
    const billingCode: string = details && details.billingCode !== null ? details.billingCode : ''
    const repSignature =
      trip && trip.representativeSignature !== '' && trip.representativeSignature !== null
        ? `https://${getBucketName()}.s3.amazonaws.com/uploads/signatures/rep/${trip.representativeSignature}`
        : null
    const tripSignature =
      trip && trip.riderSignature !== '' && trip.riderSignature !== null
        ? `https://${getBucketName()}.s3.amazonaws.com/uploads/signatures/rider/${trip.riderSignature}`
        : repSignature

    return (
      <View style={[styles.tableRow]} key={prop.tripIndex}>
        <View style={[{ width: '1%', borderLeft: '1px solid black' }]}>
          <Text style={[{ fontSize: 10, textAlign: 'center' }]}>{prop.tripIndex}</Text>
        </View>
        <View style={[{ width: '10%' }]}>
          <Text style={[styles.bodyTwoLines, styles.bodyText]}>
            {trip && trip.vehicle ? trip.vehicle.licensePlate : <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>}
          </Text>
        </View>
        <View style={[{ width: '7%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip && trip.scheduledPickupTime ? (
                formatDateTime(trip.scheduledPickupTime, 'MM/DD/YY')
              ) : (
                <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>
              )}
            </Text>
          </View>
        </View>
        <View style={[{ width: '10%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {billingCode && billingCode !== '' ? billingCode : <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>}
            </Text>
          </View>
        </View>
        <View style={[{ width: '13%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip && trip.rider ? (
                <Text>{trip.rider.firstName + ' ' + trip.rider.lastName}</Text>
              ) : (
                <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>
              )}{' '}
            </Text>
          </View>
        </View>
        <View style={[{ width: '6%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip ? getPickedUpTime(trip.status) : <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>}
            </Text>
          </View>
        </View>
        <View style={[{ width: '6%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip ? (
                formatDateTime(trip.scheduledDropoffTime, 'HH:mm')
              ) : (
                <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>
              )}
            </Text>
          </View>
        </View>
        <View style={[{ width: '7%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip ? getWillCallTime(trip.status) : <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>}
            </Text>
          </View>
        </View>
        <View style={[{ width: '8%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>
              {trip ? convertToMiles(trip.estimatedDistance) : <Text style={[styles.bodyTwoLines]}>&nbsp;</Text>}
            </Text>
          </View>
        </View>
        <View style={[{ width: '11%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>&nbsp;</Text>
          </View>
        </View>
        <View style={[{ width: '10%' }]}>
          <View style={[styles.bodyTwoLines]}>
            <Text style={[styles.bodyText]}>&nbsp;</Text>
          </View>
        </View>
        <IMGSignature tripSignature={tripSignature} />
      </View>
    )
  }

  const OdometerRecord = (prop: RecordOfTripsProp) => {
    const trip = prop.trip

    return (
      <View style={[styles.tableRow, { width: '50%' }]} key={prop.tripIndex}>
        <View style={[{ width: '2%', borderLeft: '1px solid black' }]}>
          <Text style={[{ fontSize: 10, textAlign: 'center' }]}>{prop.tripIndex}</Text>
        </View>
        <View style={[{ width: '49%' }]}>
          <View style={[styles.bodyOneLine]}>
            <Text style={[styles.bodyText]}>{trip && trip.startMileage ? trip.startMileage : <Text>&nbsp;</Text>}</Text>
          </View>
        </View>
        <View style={[{ width: '49%' }]}>
          <View style={[styles.bodyOneLine]}>
            <Text style={[styles.bodyText]}>{trip && trip.endMileage ? trip.endMileage : <Text>&nbsp;</Text>}</Text>
          </View>
        </View>
      </View>
    )
  }

  React.useEffect(() => {
    if (isSubmitted) {
      props.getTripLogPerServiceAndDateRange({
        serviceId: props.serviceId,
        fromDate: fromDateFilter,
        toDate: toDateFilter,
        productIds
      })
      setIsSubmited(false)
    }
  }, [isSubmitted])

  return (
    <div>
      <label className='ml1 h5 font-red'>{filterMessage}</label>
      <div className='flex mb2 g-align-items-end'>
        <div className='ml1 col-2'>
          <label className='h5'>From</label>
          <Datetime className='mt1 datepickerStyle' value={fromDateDisplay} onChange={setFromDateFilter} />
        </div>
        <div className='ml1 col-2'>
          <label className='h5'>To</label>
          <Datetime className='mt1 datepickerStyle' value={toDateDisplay} onChange={setToDateFilter} />
        </div>
        <div className='ml1 col-2'>
          <label className='h5'>Select Product</label>
          <Select
            classNamePrefix='select-control'
            options={options}
            value={options.filter((op: any) => productIds.includes(op.value))}
            onChange={selectProductIds}
            isMulti={true}
          />
        </div>
        <div className='ml1'>
          <button
            className='btn bg-green rounded font-white weight-200'
            onClick={() => {
              setIsSubmited(true)
            }}
          >
            {UIMessages.service.generate}
          </button>
        </div>
      </div>
      {props.dailyTripLogs && props.dailyTripLogs.length && props.dailyTripLogs.length > 0 ? (
        <PDFDownloadLink document={<ModivCareTripLog dailyTripsLog={props.dailyTripLogs} />} fileName={filename}>
          {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
        </PDFDownloadLink>
      ) : (
        <div>No trip data</div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/services/view/pdfs/ModivcareTripLogPDFNew.tsx